











































































































import { getOperationPlansSent } from "@/services";
import { OperationPlansSentElement, SurveyStatusResult } from "@/interfaces";
import { Component, Vue } from "vue-property-decorator";

import { date } from "quasar";
import { AuthModule } from "@/store";

@Component
export default class OperationPlansSent extends Vue {
  @AuthModule.bindings.Getter
  isAdministrator!: boolean;

  @AuthModule.bindings.State
  status!: SurveyStatusResult;

  loading = false;
  elements: OperationPlansSentElement[] = [];

  searchText = "";
  planningYear: number | null = null;

  mounted() {
    if (this.isAdministrator) {
      const planningYears = [...this.status.planning_years];
      const planningYear = planningYears.pop();

      if (planningYear) {
        this.planningYear = planningYear;
      }
    }

    this.loadMatrix();
  }

  async loadMatrix() {
    try {
      this.loading = true;

      if (this.isAdministrator) {
        this.elements = await getOperationPlansSent(this.planningYear === null ? 2022 : this.planningYear);
      } else {
        this.elements = await getOperationPlansSent();
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  getElementDate(element: OperationPlansSentElement) {
    if (element.updated_at) {
      return date.formatDate(element.updated_at, "DD/MM/YYYY HH:mm");
    }

    return "";
  }

  get columns() {
    const cols: any = [
      {
        name: "name",
        label: this.isAdministrator ? "Ambito" : "Piano Operativo",
        field: "name",
        align: "left",
        sortable: true,
      },
      { label: "Ultima modifica", name: "date", align: "left" },
      { label: "", name: "download", align: "center" },
    ];

    return cols;
  }

  get filteredElements() {
    return this.elements.filter(element => element.name.toLowerCase().includes(this.searchText.toLowerCase()));
  }
}
